function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "plusIconTitle"
}, "Plus");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "plusIconDesc"
}, "Plus icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.35 0C20.73 0 26.7 5.98 26.7 13.35c0 7.37-5.98 13.35-13.35 13.35C5.98 26.7 0 20.72 0 13.35 0 5.98 5.98 0 13.35 0zm4.56 11.94h-3.14V8.8c0-.77-.65-1.4-1.42-1.4-.77 0-1.42.63-1.42 1.4v3.14H8.8c-.77 0-1.4.65-1.4 1.42 0 .77.63 1.42 1.4 1.42h3.14v3.14c0 .77.65 1.4 1.42 1.4.77 0 1.42-.63 1.42-1.4v-3.14h3.14c.77 0 1.4-.65 1.4-1.42 0-.77-.64-1.42-1.41-1.42z"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "currentColor",
    "aria-labelledby": "plusIconTitle plusIconDesc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "plusIconTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.8006dc70.svg";
export { ForwardRef as ReactComponent };